import {Component, OnInit} from '@angular/core';
import {LanguageService} from '../../../services/languages/language.service';
import {NavBarService} from '../../../services/nav-bar/nav-bar.service';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent implements OnInit {
  
  isContactFormShown: boolean;
  
  constructor(public ls: LanguageService, private nav: NavBarService) {
  }
  
  ngOnInit() {
    this.isContactFormShown = false;
    setTimeout(() => {
      this.nav.deselectAll();
      this.nav.contactsSelected = true;
    }, 0);
  }
}
